//import React, { Component } from 'react'; // class 컴포넌트 사용할 때
import React from 'react';  // function 컴포넌트를 사용할 때
import PropTypes from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import './Movie.css';
/*

// class (똑똑한) 컴포넌트
class Movie extends Component {

    static propTypes = {
		title: PropTypes.string.isRequired,
		poster: PropTypes.string.isRequired,
	}

    render() {
        //console.log(this.props);
      return (
        <div>
            <MoviePoster poster={this.props.poster} />
            <h1>{this.props.title}</h1>
        </div>
      )
    }
}
*/
/*
class MoviePoster extends Component{

	static propTypes = {
		poster: PropTypes.string.isRequired
	}

    render(){
        //console.log(this.props);
        return(
            <img src={this.props.poster} width="200" alt="img" />
        )
    }
}
*/



// function (멍청한)컴포넌트를 사용하면 state를 사용할 필요가 없음, this도 포함이 안되어있기 때문에 사용 x 
function Movie({ title, poster, genres, synopsis }) {
    return (
        <div className="Movie">
            <div className="Movie_Columns">
                <MoviePoster poster={poster} alt={title} />
            </div>
            
            <div className="Movie_Columns">
                <h1>{title}</h1>
                <div className="Movie_Genres">
                    {genres.map((genre, index) => <MovieGenre genre={genre} key={index} />)}
                </div>
                <p className="Movie_Synopsis">
                    <LinesEllipsis
                        text={synopsis}
                        maxLine='4'
                        ellipsis='...'
                        trimRight
                        basedOn='letters'
                    />
                </p>
            </div>
        </div>
    )
}

function MoviePoster({poster, alt}) {
    return (
        <img src={poster} alt={alt} title={alt} className="Movie_Poster"/>
    )
}

function MovieGenre({ genre }) {
    return (
        <span className="Movie_Genre">{genre}</span>
    )
}

Movie.propTypes = {
    title: PropTypes.string.isRequired,
    poster: PropTypes.string.isRequired,
    genres: PropTypes.array.isRequired,
    synopsis: PropTypes.string.isRequired,
}

MoviePoster.propTypes = {
    poster: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
}
MovieGenre.propTypes = {
    genres: PropTypes.string.isRequired,
}

export default Movie


// WEBPACK FOOTER //
// ./src/Movie.js